define('app/views/yadis_checkout_gift_message',['app/setup','jquery.cookie'], function(takhfifan, jq_cookie) {

  takhfifan.YadisaCheckoutGiftMessage = Backbone.View.extend({

    events: {
      'change input[data-name="giftmessageFrom"]': 'update',
      'change input[data-name="giftmessageTo"]': 'update',
      'change textarea[data-name="giftmessageMessage"]': 'update'
    },

    initialize: function (options) {
      if (!String.prototype.trim) {
        String.prototype.trim = function () {
          return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        };
      }

      this.id = this.$el.find('input[name="quoteID"]').val();

      this.from = $.cookie('gm-'+this.id+'-from') || this.$el.find('input[data-name="giftmessageFrom"]').val();
      this.to = $.cookie('gm-'+this.id+'-to') || this.$el.find('input[data-name="giftmessageTo"]').val();
      this.msg = $.cookie('gm-'+this.id+'-msg') || this.$el.find('textarea[data-name="giftmessageMessage"]').val();
      this.inputCoockieMap = {
        'giftmessageFrom' : 'gm-'+this.id+'-from',
        'giftmessageTo' : 'gm-'+this.id+'-to',
        'giftmessageMessage' : 'gm-'+this.id+'-msg'
      };

      this.$el.find('input[data-name="giftmessageFrom"]').val(this.from);
      this.$el.find('input[data-name="giftmessageTo"]').val(this.to);
      this.$el.find('textarea[data-name="giftmessageMessage"]').val(this.msg);

      takhfifan.eventHub.on('yadisa:giftWrapSelected', function() {
        this.$el.show();
      }, this);
    },

    update: function (e) {
      var $target = $(e.target),
          inputKey = $target.attr('data-name'),
          inputVal = $target.val().trim();

      $.cookie(this.inputCoockieMap[inputKey], inputVal, { expires: 1/24});
    }
  })
});
